import service from "../utils/axios";

// 获取发票可用订单
const getInvoiceAvailableOrders = () => {
  return service.get("/invoice/orders/available");
};

// 申请发票
const applyInvoice = (data) => {
  return service.post("/invoice/apply", data);
};

// 搜索公司抬头
const searchCompanyHeader = (data) => {
  return service.get("/invoice/company/search", { params: data });
};

// 获取最近一次开票的电子邮箱
const getLastInvoiceEmailEmail = () => {
  return service.get("/invoice/email/last");
};

// 获取发票列表
const getInvoiceList = (data) => {
  return service.get("/invoice/list", { params: data });
};

// 获取发票详情
const getInvoiceDetail = (data) => {
  return service.get("/invoice/detail", { params: data });
};

// 换开发票
const reissueInvoice = (data) => {
  return service.post(`/invoice/reissue?invoice_id=${data.invoice_id}`, {
    ...data.rawSubmitData,
  });
};

// 发票重新申请
const reapplyInvoice = (data) => {
  return service.post(`/invoice/retry?invoice_id=${data.invoice_id}`);
};

// 发送发票邮箱
const sendEmailInvoice = (data) => {
  return service.post(`/invoice/email/send?invoice_id=${data.invoice_id}`, {
    email: data.email,
  });
};

export {
  getInvoiceAvailableOrders,
  applyInvoice,
  searchCompanyHeader,
  getLastInvoiceEmailEmail,
  getInvoiceList,
  getInvoiceDetail,
  reissueInvoice,
  reapplyInvoice,
  sendEmailInvoice,
};
